import { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { fetchTotalCountsAction } from "../../actions/dashboardActions";
import { toast } from "react-toastify";

export const dashboardStatsConfig = [
  {
    key: "totalClients",
    title: "Total Clients",
    iconName: "groupIcon",
    color: "#4a90e2",
    filterKey: "entityCategory",
    filterValue: "client",
  },
  {
    key: "totalServicePartner",
    title: "Total Service Partner",
    iconName: "groupIcon",
    color: "#f39c12",
    filterKey: "entityCategory",
    filterValue: "vendor",
  },
  {
    key: "totalPendings",
    title: "Pending",
    iconName: "documentsIcon",
    color: "#e74c3c",
    filterKey: "documentStatus",
    filterValue: "pending",
  },
];

export const getFormattedStatValue = (value, isLoading) => {
  if (isLoading) return "...";
  if (value === null || value === undefined) return "0";
  return value.toString();
};

export const useDashboardCounts = () => {
  const [counts, setCounts] = useState({
    totalClients: 0,
    totalServicePartner: 0,
    totalPendings: 0,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const isLoadingRef = useRef(false);

  const loadDashboardCounts = useCallback(
    async (cancelled = { current: false }) => {
      isLoadingRef.current = true;
      setIsLoading(true);
      setError(null);
      try {
        const response = await fetchTotalCountsAction();
        if (cancelled.current) return;
        if (response.success) {
          setCounts(response.data);
        } else {
          const msg = response.message || "Failed to load dashboard counts";
          setError(msg);
          toast.error(msg);
        }
      } catch {
        if (cancelled.current) return;
        toast.error("Failed to load dashboard counts");
      } finally {
        if (!cancelled.current) setIsLoading(false);
        isLoadingRef.current = false;
      }
    },
    [],
  );

  useEffect(() => {
    const cancelled = { current: false };
    loadDashboardCounts(cancelled);
    return () => {
      cancelled.current = true;
    };
  }, [loadDashboardCounts]);

  return { counts, isLoading, error, refetch: loadDashboardCounts };
};

export const getStatsArray = (counts, isLoading) => {
  return dashboardStatsConfig.map((config) => ({
    ...config,
    value: getFormattedStatValue(counts[config.key], isLoading),
  }));
};

export const useDashboard = () => {
  const { counts, isLoading } = useDashboardCounts();
  const stats = getStatsArray(counts, isLoading);
  const navigate = useNavigate();

  const handleCardClick = (stat) => {
    const query = stat.filterKey
      ? `?${stat.filterKey}=${stat.filterValue}`
      : "";
    navigate(`/all-list${query}`);
  };

  return { stats, isLoading, handleCardClick };
};
